module.exports = __webpack_public_path__ + "static/media/fontello.d6203101.woff";